
//66
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "border2453587625",
    {"root":"border2453587625--root","radius02":"2px","radius04":"4px","radius06":"6px","radius08":"8px","round":"50%"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/border.st.css
// module id = 1366
// module chunks = 0